import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const isAuthenticated = localStorage.getItem('is_authenticated');
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/restaurant/login" state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0) {
    try {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const userType = userData.userType;
      
      if (!userType || !allowedRoles.includes(userType)) {
        // Fallback redirects if accessing an unauthorized domain
        if (userType === 'restaurant') return <Navigate to="/restaurant/dashboard" replace />;
        if (userType === 'staff') return <Navigate to="/restaurant-staff/employee" replace />;
        if (userType === 'admin') return <Navigate to="/admin/dashboard" replace />;
        if (userType === 'vendor') return <Navigate to="/vendor/dashboard" replace />;
        if (userType === 'customer') return <Navigate to="/customer" replace />;
        
        return <Navigate to="/restaurant/login" replace />;
      }
    } catch (err) {
      return <Navigate to="/restaurant/login" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
